/**
 * Cache time constants for Pinia Colada queries.
 *
 * Global defaults (from main.js):
 * - staleTime: 5 minutes
 * - gcTime: 30 minutes
 * - refetchOnMount: true
 * - refetchOnWindowFocus: false
 * - refetchOnReconnect: false
 *
 * Use CACHE_TIMES to override staleTime based on your data's update characteristics.
 *
 * @see docs/guidelines/state-management.md
 *
 * @example
 * useQuery({
 *   key: ['categories'],
 *   query: () => fetchCategories(),
 *   staleTime: CACHE_TIMES.STATIC,
 * })
 */
export const CACHE_TIMES = {
  /** Reference/static data that rarely changes (e.g., TikTok interests, categories) */
  STATIC: 8 * 60 * 60 * 1000, // 8 hours

  /** Data updated daily (analytics, insights) */
  DAILY: 60 * 60 * 1000, // 1 hour

  /** Data updated hourly (e.g., Social Listening aggregations) */
  HOURLY: 30 * 60 * 1000, // 30 min

  /** Default - frequently updated data (matches global default) */
  STANDARD: 5 * 60 * 1000, // 5 min

  /** User-editable data (topics, campaigns lists) */
  MUTABLE: 2 * 60 * 1000, // 2 min

  /** Live/real-time data (notifications, status) */
  REALTIME: 30 * 1000, // 30 sec
} as const;

export const INSIGHTS_QUERY_OPTIONS = { staleTime: CACHE_TIMES.DAILY } as const;
export const MUTABLE_QUERY_OPTIONS = { staleTime: CACHE_TIMES.MUTABLE } as const;
